import gsap from 'gsap';

class FeedTabs {
	static instance = null;

	static create(tabs) {
		if (FeedTabs.instance === null) {
			if (!!tabs.length) {
				FeedTabs.instance = new FeedTabs(tabs);
			}
		}
	}

	static destroy() {
		if (FeedTabs.instance) {
			FeedTabs.instance.beforeDestroy();
			FeedTabs.instance = null;
		}
	}

	constructor(tabs) {
		this.active = true;
		this.tabs = tabs;
		this.init();
	}

	init() {
		this.tabs.forEach(tab => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				if (this.active) this.openTab(tab);

			});

			if (tab.classList.contains('active')) {
				this.openTab(tab);
			}
		});
	}

	openTab(tab) {
		if (tab.classList.contains('active')) return false;

		const tabId = tab.dataset.tabFeed;
		const parent = tab.closest('.tab-nav');
		const siblings = [...parent.querySelectorAll('[data-tab-feed]')].filter(child => child !== tab);
		const cardsLeave = [];
		const cardsEnter = [];
		let tabLeave = null;
		let tabContentLeave = null;
		let tabContentEnter = null;
		this.active = false;

		siblings.forEach(sibling => {
			if (sibling.classList.contains('active')) {
				tabLeave = sibling;
				const siblingId = sibling.dataset.tabFeed;
				tabContentLeave = document.getElementById(`${siblingId}`);
				if (tabContentLeave) {
					const cards = tabContentLeave.querySelectorAll('.card-container');
					cards.forEach(card => {
						cardsLeave.push(card);
					})
				}
			}
		});

		tabContentEnter = document.getElementById(`${tabId}`);
		if (tabContentEnter) {
			const cards = tabContentEnter.querySelectorAll('.card-container');
			cards.forEach(card => {
				cardsEnter.push(card);
			});
		}

		if (tabContentLeave && tabContentEnter) {
			tabLeave.classList.remove('active');
			tab.classList.add('active');

			const tl = gsap.timeline({
				onComplete: () => {
					this.active = true;
				}
			});
			if (cardsLeave.length > 0) {
				tl.to(cardsLeave, {
					duration: 0.3,
					y: -30,
					opacity: 0,
					stagger: 0.1,
					ease: 'power3.inOut'
				});
			}
			tl.add(() => {
				tabContentLeave.classList.remove('active');
				tabContentEnter.classList.add('active');
			})
			if (cardsEnter.length > 0) {
				tl.from(cardsEnter, {
					duration: 0.5,
					y: 50,
					opacity: 0,
					stagger: 0.1,
					ease: 'power3.inOut'
				});
			}
			tl.set(cardsLeave, {y: 0, opacity: 1});
		}


		let offset = $('#header').outerHeight();
		setTimeout(() => {
			gsap.to(window, {
				duration: 0.2,
				scrollTo: {
					y: tab.closest('.news-feed'),
					offsetY: offset
				}
			})
		}, 20);
	}

	beforeDestroy() {
		this.tabs.forEach(tab => {
			tab.removeEventListener('click', () => {
				this.openTab(tab);
			});
		});

		this.tabs = null;
	}
}

export default FeedTabs;
